module.exports = __webpack_public_path__ + "static/media/thumbnail.44a5b515.jpg";